<template>
  <div class="building3DModel">3D模型</div>
</template>

<script>
export default {

}
</script>

<style>

</style>